// Get Items
export const SHARED_GET_ALL_SHARED_ITEMS_WITH_ME_REQUEST = 'SHARED_GET_ALL_SHARED_ITEMS_WITH_ME_REQUEST';
export const SHARED_GET_ALL_SHARED_ITEMS_WITH_ME_SUCCESS = 'SHARED_GET_ALL_SHARED_ITEMS_WITH_ME_SUCCESS';
export const SHARED_GET_ALL_SHARED_ITEMS_WITH_ME_FAILURE = 'SHARED_GET_ALL_SHARED_ITEMS_WITH_ME_FAILURE';

export const PREVIEW_FILE = 'PREVIEW_FILE';